import { useEffect } from 'react';

import { useAppDispatch as useDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import { productsCategories } from 'constants/products';

import * as consultationSelectors from 'dux/consultation/selectors';
import * as consultationThunks from 'dux/consultation/thunks';

export const useGetProductIngredientsListModal = (shouldLoadFullList, category) => {
  const dispatch = useDispatch();

  // skincare or haircare ingredients lists

  // request error selector
  const errorSelectorFromCategory =
    category === productsCategories.SKINCARE
      ? consultationSelectors.getSkincareIncisError
      : consultationSelectors.getHaircareIncisError;

  // request status selector
  const statusSelectorFromCategory =
    category === productsCategories.SKINCARE
      ? consultationSelectors.getSkincareIncisStatus
      : consultationSelectors.getHaircareIncisStatus;

  // products ingredients data (incis) selector
  const incisListSelectorFromCategory =
    category === productsCategories.SKINCARE
      ? consultationSelectors.getOrderedIncisData
      : consultationSelectors.getHaircareIncisData;

  const incisStatus = useSelector(statusSelectorFromCategory);
  const incisError = useSelector(errorSelectorFromCategory);
  const incisList = useSelector(incisListSelectorFromCategory);

  const fetchIncisFromCategory = () =>
    category === productsCategories.SKINCARE
      ? dispatch(consultationThunks.fetchSkincareIncis())
      : dispatch(consultationThunks.fetchHaircareIncis());

  useEffect(() => {
    if (shouldLoadFullList && incisStatus === 'idle') {
      fetchIncisFromCategory();
    }
  }, [shouldLoadFullList, incisStatus]);

  return {
    incisList,
    incisError,
    incisStatus,
  };
};

export const useGetSkinCareProductIngredientsList = () => {
  const dispatch = useDispatch();

  // skincare ingredients selectors
  const error = useSelector(consultationSelectors.getSkincareIngredientsError);
  const status = useSelector(consultationSelectors.getSkincareIngredientsStatus);
  const ingredientsData = useSelector(consultationSelectors.getSkincareIngredientsData);
  const fetchSkincareIngredients = () => dispatch(consultationThunks.fetchSkincareIngredients());

  useEffect(() => {
    if (status === 'idle') {
      fetchSkincareIngredients();
    }
  }, [status]);
  return {
    error,
    fetchSkincareIngredients,
    ingredientsData,
    status,
  };
};
